import { render, staticRenderFns } from "./Fightboard.vue?vue&type=template&id=5f159be4&"
import script from "./Fightboard.vue?vue&type=script&lang=js&"
export * from "./Fightboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports